/**
 * The one-line pointer under a role's opening round: who was invited and never booked, and the
 * single place a second chance may be sent from.
 *
 * Split out of `InvitedAlready.tsx` when the three per-round lists became one shared strip
 * (`RolePipeline`). The list moved; this did not, because it is specific to the opening round —
 * only an invitation can go unanswered, and only the SLA tab may replace one.
 *
 * Deliberately quiet: smaller than the card's own text, no panel, no fill. Dressing it as an
 * alert made it compete with the work above it. The ⚠️ carries the urgency instead — an
 * envelope read as "an email happened", which is the opposite of the point.
 */
export function HiddenNote({ count, onGoToSla }: { count: number; onGoToSla?: () => void }) {
  if (count <= 0) return null;
  const plural = count !== 1;
  return (
    <p className="px-1 pt-1 text-xs leading-relaxed text-gray-500" role="status">
      ⚠️ {count} of the invited {plural ? 'have' : 'has'} not booked yet.{' '}
      {onGoToSla ? (
        <button
          type="button"
          onClick={onGoToSla}
          className="border-0 bg-transparent p-0 text-xs font-semibold text-blue-600 underline hover:opacity-80"
        >
          Chase them under ⏰ SLA
        </button>
      ) : (
        <span className="font-semibold">Chase them under ⏰ SLA</span>
      )}
      , where an expired link can be replaced — each candidate gets one second chance.
    </p>
  );
}
